import { render } from "./TalkjsTrigButton.vue?vue&type=template&id=745d9c1c&scoped=true"
import script from "./TalkjsTrigButton.vue?vue&type=script&lang=js"
export * from "./TalkjsTrigButton.vue?vue&type=script&lang=js"

import "./TalkjsTrigButton.vue?vue&type=style&index=0&id=745d9c1c&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745d9c1c"]])

export default __exports__